/**
 * Knowledge Base Service - Handles API interactions for knowledge base management
 */

import { get, post, put, del } from "../utils/apiUtils";


// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/mms_persistence/entity`;
const ENTITY_PERSISTANCE_URL = `/api/v1/mms_persistence/`;
const ENTITY_URL = `/api/v1/mms_ai_configs/entities/config/`;
const ENTITY_LIST_URL = `/api/v1/mms_ai_entities/entities/update`;
const KB_CODES_URL = `/api/v1/mms_ai_configs/knowledgebase/config/fetch`;
const ENTITY_DATA_API = `/api/v1/mms_ai_entity_service/entity/data`;


/**
 * Get all Entities bases with optional filtering
 * @param {Object} filter - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const getEntitiesByPagination = async (filter = {}, sort ={}, query = {}) => {
  try {
    const {skip = 0, limit = 10} = query;
    const response = await post(`${ENTITY_URL}fetch`, { filter, sort, skip, limit });
    return response;
  } catch (error) {
    console.error('Error fetching entities:', error);
    throw error;
  }
};

/**
 * Get all Entities bases with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const listAllEntities = async (tableName,filter = {}, sort ={}, query =null) => {
  try {
    const response = await post(`/api/v1/mms_persistence/${tableName}/fetch?${query}`, { filter: filter,sort });
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};

/**
 * Get a specific entity by ID
 * @param {string} entityId - entity ID
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const getEntityById = async (entityId) => {
  let filter = {
    id: entityId
  }
  let sort ={}
  try {
    const response = await post(`${API_URL}/fetch?query=null`, { filter, sort });
    if(response && response.length > 0) {
      return response[0];
    }else{
      return null;
    }
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};

/**
 * Get a specific entity by ID
 * @param {string} entityId - entity ID
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const getEntityByFilter = async (filter) => {
  let sort ={}
  try {
    const response = await post(`${API_URL}/fetch?query=null`, { filter, sort });
    if(response && response.length > 0) {
      return response[0];
    }else{
      return null;
    }
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};


/**
 * Get a kb codes by entity names
 * @returns {Promise<Object>} Promise resolving to kb object
 */
export const getKBCodesByFilter = async (filter = {}) => {
  let sort = null;
  try {
    const response = await post(`${KB_CODES_URL}`, { filter, sort });
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases codes:', error);
    throw error;
  }
};



/**
 * 
 * @returns {Promise<Object>} Promise resolving to kb object
 */
export const createEntityData = async ( payload = {}, entityName) => {
  try {
    const response = await post(`${ENTITY_DATA_API}/${entityName}`, payload);
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases codes:', error);
    throw error;
  }
};


/**
 * 
 * @returns {Promise<Object>} Promise resolving to kb object
 */
export const updateEntityData = async ( payload = {}, entityName) => {
  try {
    const response = await put(`${ENTITY_DATA_API}/${entityName}`, payload);
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases codes:', error);
    throw error;
  }
};




/**
 * Get a specific entity by ID
 * @param {string} entityCode - entity Code
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const getEntityByCode = async (entityCode) => {
  try {
    const response = await get(`${ENTITY_URL}get_by_cd/${entityCode}`);
    return response
  } catch (error) {
    console.error('Error fetching entity:', error);
    throw error;
  }
};


/**
 * Get a specific entity by ID
 * @param {string} entityCode - entity Code
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const getEntityDataByPagination = async (entityName, filter, sort, query) => {
  try {
    const {skip = 0, limit = 10} = query;
    const response = await post(`${ENTITY_DATA_API}/${entityName}/fetch`, {filter, sort, skip, limit});
    return response
  } catch (error) {
    console.error('Error fetching entity:', error);
    throw error;
  }
};

/**
 * Get a specific entity by ID
 * @param {string} entityCode - entity Code
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const deleteEntityDataById = async (entityName, Id) => {
  try {
    const response = await del(`${ENTITY_DATA_API}/${entityName}/${Id}`);
    return response
  } catch (error) {
    console.error('Error fetching entity:', error);
    throw error;
  }
};


/**
 * Update a specific entity
 * @param {string} entity - entity
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const updateEntity = async (entity) => {
  
  try {
    const response = await put(`${ENTITY_URL}`, entity);
    return response;
  } catch (error) {
    console.error('Error updating the entity:', error);
    throw error;
  }
};


/**
 * create a specific entity
 * @param {string} entity - entity
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const createEntity = async (entity) => {
  
  try {
    const response = await post(`${ENTITY_URL}`, entity);
    return response;
  } catch (error) {
    console.error('Error creating entity:', error);
    throw error;
  }
};


/**
 * Update a specific entity
 * @param {string} entity - entity
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const fetchEntityCount = async () => {
  
  try {
    const response = await post(`${API_URL}/count`, {});
    return response.count;
  } catch (error) {
    console.error('Error fetching entity:', error);
    throw error;
  }
};

/**
 * Update a specific entity
 * @param {string} entity - entity
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const getEntityListCount = async (entity, filter) => {
  
  try {
    const response = await post(`${ENTITY_PERSISTANCE_URL}${entity}/count`, {filter});
    return response.count;
  } catch (error) {
    console.error('Error fetching entity:', error);
    throw error;
  }
};


/**
 * FetchCOunt
 * @param {string} table_name - 
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const fetchCountByFilter = async (table_name, query) => {
  // Create a request key based on the table name
  // (removed unused requestId generation)
  const tableKey = `${table_name}${JSON.stringify(query)}`

  
  // Store active requests in this map to prevent duplicates
  if (!window._activeCountRequests) {
    window._activeCountRequests = new Map();
  }
  
  // If an identical request is already in progress, cancel this one
  if (window._activeCountRequests.has(tableKey)) {
    console.log(`Duplicate count request for ${tableKey} detected, using existing request`);
    return window._activeCountRequests.get(tableKey);
  }
  
  // Create a new promise for this request
  const countPromise = new Promise(async (resolve, reject) => {
    try {
      const response = await post(`/api/v1/mms_persistence/${table_name}/count`, query);
      window._activeCountRequests.delete(tableKey);
      resolve(response.count);
    } catch (error) {
      // Check if this is a canceled request error
      if (error.name === 'CanceledError' || (error.message && error.message.includes('canceled'))) {
        console.log(`Request for ${tableKey} was canceled, likely a duplicate`);
        resolve(0); // Return a safe default value
      } else {
        console.error(`Error fetching count for ${tableKey}:`, error);
        window._activeCountRequests.delete(tableKey);
        reject(error);
      }
    }
  });
  
  // Store this promise
  window._activeCountRequests.set(tableKey, countPromise);
  
  return countPromise;
};


/**
 * Get all Entities bases with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const getAllEntitiesByFilter = async (filter = {}, sort ={}, query =null) => {
  try {
    const response = await post(`${API_URL}/fetch?${query}`, { filter: filter,sort });
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};

/**
 * Update a specific entity list item
 * 
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const updateEntityListItem = async (data) => {
  
  try {
    const { entity_code } = data;
    const response = await put(`${ENTITY_LIST_URL}/${entity_code}`, data);
    return response;
  } catch (error) {
    console.error('Error updating entity list item:', error);
    throw error;
  }
};





export default {
  getEntityById,
  updateEntity,
  createEntity,
  fetchEntityCount,
  fetchCountByFilter
};

